import { motion } from 'framer-motion'
import { useNavigate } from 'react-router-dom'
import { quickSpring } from '@/lib/animations'

interface HeaderLogoProps {
  collapsed?: boolean
  title?: string | null
}

export function HeaderLogo({ collapsed, title }: HeaderLogoProps) {
  const navigate = useNavigate()

  return (
    <motion.button
      className="flex items-center focus:outline-none focus-visible:ring-2 focus-visible:ring-black focus-visible:ring-offset-2 rounded-lg"
      animate={{
        scale: collapsed ? 0.9 : 1,
      }}
      transition={quickSpring}
      whileTap={{ scale: 0.97 }}
      onClick={() => navigate('/')}
      aria-label="Go to home"
    >
      <motion.span
        className="font-display text-xl font-bold tracking-tight text-gray-900"
        animate={{ opacity: collapsed && title ? 0 : 1 }}
        transition={{ duration: 0.15 }}
      >
        Cufflink
      </motion.span>

      {title && (
        <motion.span
          className="font-sans text-base font-semibold text-gray-900 ml-2"
          initial={{ opacity: 0, x: -10 }}
          animate={{
            opacity: collapsed ? 1 : 0,
            x: collapsed ? 0 : -10,
          }}
          transition={quickSpring}
        >
          {title}
        </motion.span>
      )}
    </motion.button>
  )
}
